import React from 'react';

const App = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const event_id = urlParams.get('q');
  if(event_id !== undefined && event_id !== ""){
    window.location.href = "https://miracledome.page.link/?link=https%3A%2F%2Fweb.icsi.lk%2Fqr%2F%3Fid%3D" + event_id + "&apn=com.ceyentra.miracledome&ibi=com.ceyentra.miracledome";
  }else{
    window.location.replace(window.location.origin);
  }
};
export default App;
